import React from 'react';
export default function GasIdentity({ size = 40 }) {
  return <span className="gas-orb" style={{ width: size, height: size }} aria-hidden="true">
    <svg viewBox="0 0 64 64" fill="none"><circle cx="32" cy="32" r="25" stroke="currentColor" strokeWidth="2" opacity=".6" />
      <path d="M10 22C17 6 42 3 53 19M54 42C46 58 23 60 11 47" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M43 24a15 15 0 1 0 1 15H32l3-6h17c-1 14-10 22-23 20C7 50 9 18 31 16c7 0 12 2 16 5l-4 3Z" fill="currentColor" />
    </svg>
  </span>;
}
